import { render, staticRenderFns } from "./CleanList.vue?vue&type=template&id=fd6b7804"
import script from "./CleanList.vue?vue&type=script&lang=js"
export * from "./CleanList.vue?vue&type=script&lang=js"
import style0 from "./CleanList.vue?vue&type=style&index=0&id=fd6b7804&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports